/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConfirmPendingEmailResultDto } from '../models/ConfirmPendingEmailResultDto';
import type { CreateAccountDto } from '../models/CreateAccountDto';
import type { EmailVerifiedDto } from '../models/EmailVerifiedDto';
import type { RequestEmailVerificationDto } from '../models/RequestEmailVerificationDto';
import type { RequestPhoneVerificationCodeResult } from '../models/RequestPhoneVerificationCodeResult';
import type { RequestPhoneVerificationDto } from '../models/RequestPhoneVerificationDto';
import type { RequestPhoneVerificationResponseDto } from '../models/RequestPhoneVerificationResponseDto';
import type { UpdateAccountDto } from '../models/UpdateAccountDto';
import type { UserDto } from '../models/UserDto';
import type { VerifyPhoneDto } from '../models/VerifyPhoneDto';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class AccountsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @returns UserDto Created
     * @throws ApiError
     */
    public postApiV2Accounts(
        requestBody?: CreateAccountDto,
    ): CancelablePromise<UserDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v2/accounts',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public patchApiV2Accounts(
        requestBody?: UpdateAccountDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/v2/accounts',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns RequestPhoneVerificationResponseDto Success
     * @throws ApiError
     */
    public postApiV2AccountsPhoneVerifications(
        requestBody?: RequestPhoneVerificationDto,
    ): CancelablePromise<RequestPhoneVerificationResponseDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v2/accounts/phone-verifications',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public postApiV2AccountsVerifiedPhones(
        requestBody?: VerifyPhoneDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v2/accounts/verified-phones',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns RequestPhoneVerificationCodeResult Success
     * @throws ApiError
     */
    public postApiV2AccountsPhoneVerificationsCode(
        requestBody?: RequestPhoneVerificationDto,
    ): CancelablePromise<RequestPhoneVerificationCodeResult> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v2/accounts/phone-verifications-code',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public postApiV2AccountsEmailVerification(
        requestBody?: RequestEmailVerificationDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v2/accounts/email-verification',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ConfirmPendingEmailResultDto Success
     * @throws ApiError
     */
    public postApiV2AccountsEmailVerified(
        requestBody?: EmailVerifiedDto,
    ): CancelablePromise<ConfirmPendingEmailResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v2/accounts/email-verified',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }
}
